export const mapActions = {
  scrollTo: () => {},
  panTo: () => {},
};
